export enum TokensEnum {
  AccessToken = 'C2KAT',
  UserId = 'C2KUI',
  CompanyId = 'C2KCI',
  PharmacyId = 'C2KPI',
  LockScreen = 'C2KLS',
}
